import { getTransferrableProps } from '../utils/getTransferrableProps';
import { useCallback } from 'react';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useProperty } from '../v2/hooks/useProperty';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputCheckbox = props => {
  const {
    disabled,
    onChange,
    readOnly,
    autoFocus,
    inputRef
  } = props;
  const property = useProperty();
  const value = usePropertyValue();
  useComponentMountMetric('PropertyInputCheckbox');
  const handleChange = useCallback(({
    target: {
      checked
    }
  }) => onChange(syntheticEvent(checked ? 'true' : 'false')), [onChange]);
  return /*#__PURE__*/_jsx(Checkbox, Object.assign({}, getTransferrableProps(props), {
    readOnly: readOnly,
    autoFocus: autoFocus,
    disabled: disabled,
    onChange: handleChange,
    checked: value === 'true',
    ref: inputRef,
    children: property && property.description
  }));
};
export default PropertyInputCheckbox;